import { memo } from "react";
import OwnerDashboardEmployeeBarChart from "./OwnerDashboardEmployeeBarChart";
import OwnerDashboardEmployeeBCDetail from "./OwnerDashboardEmployeeBCDetail";

const OwnerDashboardEmployeePage = memo(({ data, filterValue, loading }) => {
  return (
    <div className="w-full col-center-start gap-4">
      <OwnerDashboardEmployeeBCDetail
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
      <div className="w-full flex flex-col sm:flex-row gap-2">
        <div className="w-full sm:w-[50%]">
          <OwnerDashboardEmployeeBarChart
            data={data?.sales_by_doctor}
            labelKey={"doctor_name"}
            valueKey={"total"}
            title="Doctor Receipts"
            filterValue={filterValue}
            loading={loading}
          />
        </div>
        <div className="w-full sm:w-[50%]">
          <OwnerDashboardEmployeeBarChart
            data={data?.sales_by_nurse}
            labelKey={"nurse_name"}
            valueKey={"total_receipts"}
            title="Nurse Receipts"
            filterValue={filterValue}
            loading={loading}
          />
        </div>
      </div>
      <OwnerDashboardEmployeeBarChart
        data={data?.sales_by_therapist}
        labelKey={"therapist_name"}
        valueKey={"total_receipts"}
        title="Therapist Receipts"
        filterValue={filterValue}
        loading={loading}
      />
    </div>
  );
});

export default OwnerDashboardEmployeePage;
